<div class="legend-content">
    <!-- REDLINES -->
    @if (redlineDataSource.data.length > 0) {
        @if (dataSource.data.length > 0) {
            <h2 class="mat-h3">Redline Layers</h2>
        }
        <mat-tree #redlineTree [dataSource]="redlineDataSource" [childrenAccessor]="redlineChildAccessor">
            <!-- this is an expandable layer node (has more than 1 class) -->
            <mat-nested-tree-node *matTreeNodeDef="let redlineNode; when: redlineHasMultipleClasses">
                <div class="mat-tree-node legend-node layer-node expandable-node">
                    <button mat-icon-button matTreeNodeToggle
                            [attr.aria-label]="'toggle ' + redlineNode.label">
                        <mat-icon class="mat-icon-rtl-mirror"
                                  [svgIcon]="redlineTree.isExpanded(redlineNode) ? 'expand_more' : 'chevron_right'">
                        </mat-icon>
                    </button>
                    <mat-checkbox [ngModel]="redlineNode.on"
                                  [disableRipple]="true"
                                  (ngModelChange)="toggleRedlineLayer(redlineNode)"></mat-checkbox>
                    <span>{{ redlineNode.label }}</span>
                    <div class="legend-icon empty"></div>
                </div>
                <div [class.node-invisible]="!redlineTree.isExpanded(redlineNode)" class="group-container">
                    <ng-container matTreeNodeOutlet></ng-container>
                </div>
            </mat-nested-tree-node>
            <!-- this is a layer node -->
            <mat-nested-tree-node *matTreeNodeDef="let redlineNode; when: redlineHasOneClass">
                <div class="mat-tree-node legend-node layer-node class-node">
                    <mat-checkbox [ngModel]="redlineNode.on"
                                  [disableRipple]="true"
                                  (ngModelChange)="toggleLayer(redlineNode)"></mat-checkbox>
                    <span>{{ redlineNode.label }}</span>
                    @if (redlineNode.classes.length === 1) {
                        <dash-gis-redline-icon class="legend-icon"
                                               [redlineClassName]="redlineNode.classes[0].name"
                                               [redlineConfig]="redlineNode"
                        ></dash-gis-redline-icon>
                    }
                </div>
            </mat-nested-tree-node>
            <!-- this is a layer class node -->
            <mat-nested-tree-node *matTreeNodeDef="let redlineClassNode;">
                <div class="mat-tree-node legend-node class-node">
                    <div class="legend-label">{{ redlineClassNode.label }}</div>
                    <dash-gis-redline-icon class="legend-icon"
                                           [redlineClassName]="redlineClassNode.name"
                                           [redlineConfig]="redlineClassNode.parent"></dash-gis-redline-icon>
                </div>
            </mat-nested-tree-node>
        </mat-tree>
    }

    <!-- Mapserver -->
    @if (dataSource.data.length > 0) {
        @if (redlineDataSource.data.length > 0) {
            <h3>Layers</h3>
        }
        <mat-tree #mapTree [dataSource]="dataSource"
                  [childrenAccessor]="mapChildAccessor"
                  [trackBy]="trackByFn" [expansionKey]="expansionKeyFn">

            <!--this is an expandable group node -->
            <mat-nested-tree-node *matTreeNodeDef="let node; when: isExpandableGroup">
                <div class="mat-tree-node legend-node group-node expandable-node">
                    <button mat-icon-button matTreeNodeToggle
                            (click)="toggleNode(node)"
                            [attr.aria-label]="'toggle ' + node.label">
                        <mat-icon class="mat-icon-rtl-mirror"
                                  [svgIcon]="mapTree.isExpanded(node) ? 'expand_more' : 'chevron_right'">
                        </mat-icon>
                    </button>
                    @if (!node.disableToggle) {
                        <mat-checkbox
                            [ngModel]="node.status"
                            [disableRipple]="true"
                            (ngModelChange)="toggleGroup(node)"></mat-checkbox>
                    } @else {
                        <div class="no-checkbox"></div>
                    }
                    <mat-icon class="mat-icon-rtl-mirror folder-icon" svgIcon="folder"></mat-icon>
                    <span>{{ node.label }}</span>
                </div>
                <div [class.node-invisible]="!mapTree.isExpanded(node)" class="group-container">
                    <ng-container matTreeNodeOutlet></ng-container>
                </div>
            </mat-nested-tree-node>

            <!--this is a group node -->
            <mat-nested-tree-node *matTreeNodeDef="let node; when: isGroup">
                <div class="mat-tree-node legend-node group-node class-node">
                    @if (!node.disableToggle) {
                        <mat-checkbox
                            [ngModel]="node.status"
                            [disableRipple]="true"
                            (ngModelChange)="toggleGroup(node)"></mat-checkbox>
                    } @else {
                        <div class="no-checkbox"></div>
                    }
                    <mat-icon class="mat-icon-rtl-mirror folder-icon" svgIcon="folder"></mat-icon>
                    <span>{{ node.label }}</span>
                </div>
            </mat-nested-tree-node>

            <!-- this is an expandable layer node (has more than 1 class) -->
            <mat-nested-tree-node *matTreeNodeDef="let node; when: isExpandableLayer">
                <div class="mat-tree-node legend-node layer-node expandable-node">
                    <button mat-icon-button matTreeNodeToggle
                            (click)="toggleNode(node)"
                            [attr.aria-label]="'toggle ' + node.legendLabel">
                        <mat-icon class="mat-icon-rtl-mirror"
                                  [svgIcon]="mapTree.isExpanded(node) ? 'expand_more' : 'chevron_right'">
                        </mat-icon>
                    </button>
                    @if (!node.disableToggle) {
                        <mat-checkbox
                            [ngModel]="node.status"
                            [disableRipple]="true"
                            (ngModelChange)="toggleLayer(node)"></mat-checkbox>
                    } @else {
                        <div class="no-checkbox"></div>
                    }
                    <span>{{ node.label }}</span>
                </div>
                <div [class.node-invisible]="!mapTree.isExpanded(node)"
                     class="group-container class-container">
                    <ng-container matTreeNodeOutlet></ng-container>
                </div>
            </mat-nested-tree-node>

            <!-- this is a layer node (has more than 1 class) that is explicitly not expandable -->
            <mat-nested-tree-node *matTreeNodeDef="let node; when: isNonExpandableLayer">
                <div class="mat-tree-node legend-node layer-node class-node">
                    @if (!node.disableToggle) {
                        <mat-checkbox
                            [ngModel]="node.status"
                            [disableRipple]="true"
                            (ngModelChange)="toggleLayer(node)"></mat-checkbox>
                    } @else {
                        <div class="no-checkbox"></div>
                    }
                    <span>{{ node.label }}</span>
                </div>
            </mat-nested-tree-node>

            <!-- this is a layer node -->
            <mat-nested-tree-node *matTreeNodeDef="let node; when: isLayer">
                <div class="mat-tree-node legend-node layer-node class-node">
                    @if (!node.disableToggle) {
                        <mat-checkbox
                            [ngModel]="node.status"
                            [disableRipple]="true"
                            (ngModelChange)="toggleLayer(node)"></mat-checkbox>
                    } @else {
                        <div class="no-checkbox"></div>
                    }
                    <span>{{ node.label }}</span>
                    @if (node.classes.length === 1) {
                        <div class="legend-icon {{node.name}}_{{node.classes[0].index}}"></div>
                    }
                </div>
            </mat-nested-tree-node>

            <!-- this is a layer class node -->
            <mat-nested-tree-node *matTreeNodeDef="let node;">
                <div class="mat-tree-node legend-node class-node">
                    <div class="legend-label">{{ node.name }}</div>
                    <div class="legend-icon {{node.layer}}_{{node.index}}"></div>
                </div>
            </mat-nested-tree-node>
        </mat-tree>
    }
</div>


<ng-template #toggle let-node>
    <mat-checkbox [ngModel]="node.status"
                  [disableRipple]="true"
                  (ngModelChange)="toggleLayer(node)"></mat-checkbox>
</ng-template>

